var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "77.917 119.74 16 16",
    enableBackground: "new 77.917 119.74 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M92.417,122.74h-0.552l-0.571-2h-6.813l-0.389-1h-5.175v0.028c-0.581,0.017-0.811,0.369-0.896,0.582 c-0.104,0.258-0.104,0.55-0.104,0.89v13c0,0.827,0.673,1.5,1.5,1.5h13c0.827,0,1.5-0.673,1.5-1.5v-10 C93.917,123.413,93.245,122.74,92.417,122.74z M90.541,121.74l0.286,1h-5.567l-0.389-1H90.541z M92.917,134.24 c0,0.276-0.225,0.5-0.5,0.5h-13c-0.275,0-0.5-0.224-0.5-0.5v-13.031c0-0.167-0.021-0.419-0.047-0.435l0.047-0.007v-0.027h4.491 l1.167,3h7.842c0.275,0,0.5,0.225,0.5,0.5V134.24z M80.917,128.74h9v-1h-9V128.74z M80.917,131.74h3v-1h-3V131.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile01);
export default __webpack_public_path__ + "static/media/icon_file-01.906f0a0de3fd54b61537f145a6fcac81.svg";
export { ForwardRef as ReactComponent };